/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react'
import { useClickOutside, useKeydown } from '@btime/react-hooks'
import React from 'react'

import Link from '../actions/Link'
import Panel from '../structure/Panel'
import SeparatorWrapper from './SeparatorWrapper'

export const PopoverContent = ({
  render,
  fromRight,
  noPadding,
  open,
  bottomDistance,
  topDistance,
  onClose,
  parentWidth,
  minHeight
}) => {
  if (!open) return false

  const style = css`
    ${fromRight ? 'right: 0;' : 'left: 0;'}
    ${parentWidth ? 'right: 0; left: 0;' : 'width: max-content;'}
		position: absolute;
    z-index: 150;
    margin-top: ${topDistance ? `${topDistance}px` : '0px'};
    ${bottomDistance ? `bottom: ${bottomDistance};` : '0px'}
  `

  return (
    <div css={style}>
      <Panel noPadding={noPadding} smallPadding noMargin minHeight={minHeight}>
        <SeparatorWrapper weight={1}>{render()}</SeparatorWrapper>
      </Panel>
    </div>
  )
}

const Popover = ({ actionContent, children, render, renderActionContent, disabled, ...props }) => {
  const style = css`
    position: relative;
  `

  const [open, setOpen] = React.useState(false)
  const toggle = () => setOpen(!open)
  const onOpen = disabled ? undefined : () => setOpen(true)
  const onClose = () => setOpen(false)

  const wrapperRef = React.useRef(null)
  useClickOutside(wrapperRef, { action: onClose })
  useKeydown(wrapperRef, { keys: ['Escape'], action: onClose, condition: open })

  const renderContent = !!render ? () => render({ onClose, setOpen, toggle }) : () => children
  const renderAction = !!renderActionContent
    ? () => renderActionContent({ open, onClose, setOpen, toggle })
    : () => actionContent

  return (
    <div css={style} ref={wrapperRef}>
      <Link onClick={onOpen}>{renderAction()}</Link>
      <PopoverContent open={open} render={renderContent} onClose={onClose} {...props} />
    </div>
  )
}

export default Popover
